/*
 * @Author: Muyue
 * @Description:
 * @Date: 2021-04-16 14:38:39
 * @LastEditors: Muyue
 * @LastEditTime: 2021-05-28 14:13:10
 * @FilePath: \cms-app-html\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
// h5
import ArticlesShare from '../views/h5/ArticleShare'
import ArticlesShare2 from '../views/h5/ArticleShare2'
import VideoShare from '../views/h5/VideoShare'
import VideoPlayer from '../views/h5/videoPlayer'
import AppShare from '../views/h5/AppShare'
import AboutApp from '../views/h5/aboutApp'
import jimiRule from '../views/h5/JimiRule'
import Qualifications from '../views/h5/Qualifications'
import Nav from '../views/h5/Nav'
import WeappQRCode from '../views/tools/weappQRCode'
import JimiMallRule from '../views/h5/JimiMallRule.vue'
import EmergencyText from '../views/h5/emergencyText.vue'

const Instructions = () => import('../views/h5/instructions.vue')
const Pdf = () => import('../views/h5/pdf.vue')

Vue.use(Router)
/**
 * 解决报错：Navigating to current location (XXX) is not allowed
 * 原因：在路由中添加了相同的路由
 * 解决重写路由的push方法
 */
/* const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
} */
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  try {
    return routerPush.call(this, location).catch(error => error)
  } catch (e) {

  }
}

Router.prototype.getRouteByName = function (name, children) {
  let array = this.options.routes
  if (children) {
    array = children
  }
  for (let index in array) {
    let route = array[index]
    if (route.name === name) {
      return route
    }
    if (route.children) {
      let child = this.getRouteByName(name, route.children)
      if (child) {
        return child
      }
    }
  }
}

let h5routes = [

  { path: '/', redirect: '/nav' },
  { path: '/nav', component: Nav },
  { path: '/articlesShare', component: ArticlesShare },
  { path: '/articlesShare2', component: ArticlesShare2 },
  { path: '/videoShare', component: VideoShare },
  { path: '/appShare', component: AppShare },
  { path: '/aboutApp', component: AboutApp },
  { path: '/jimiRule', component: jimiRule },
  { path: '/qualifications', component: Qualifications },
  { path: '/instructions', component: Instructions },
  { path: '/videoPlayer', name: 'videoPlayer', component: VideoPlayer },
  { path: '/pdfView', name: 'pdf', component: Pdf },
  { path: '/weappQRCode', name: 'weappQRCode', component: WeappQRCode },
  { path: '/JimiMallRule', name: 'JimiMallRule', component: JimiMallRule },
  { path: '/emergencyText', name: 'emergencyText', component: EmergencyText }
]
// let webroutes = [
//   // { path: '/webDetail', component: WebDetail }
// ]
let router = null
if (entryType === 'h5') {
  router = new Router({
    routes: h5routes,
    base: '/cms-app-html',
    mode: 'history'
  })
} else {
  // router = new Router({
  //   routes: webroutes
  // })
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js